import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { authKeys } from '@core/react-query/features/auth'
import { RequestErrorType } from '@core/utils/api-axios-instance'

type ReturnType =
  | {
      result: 'USER_LINKED'
      identityProvider: string
    }
  | {
      result: 'TOKEN_EXCHANGED'
      username: string
      idToken: string
      accessToken: string
      refreshToken: string
    }

export const useCognitoExchangeToken = (
  options?: UseMutationOptions<
    ReturnType,
    RequestErrorType,
    RequestTypes['cognitoExchangeToken']
  >,
) => {
  return useMutation({
    ...authKeys.cognitoExchangeToken,
    retry: 0,
    ...options,
  })
}
